/* Heading hover: letters near the cursor push away and grow (colour stays as it is).
   Nothing runs until the pointer is near a heading. Off entirely for reduced motion. */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var doc = document;
  var R = 150;

  function split(el) {
    var cap = false;
    try { cap = window.getComputedStyle(el).textTransform === 'capitalize'; } catch (e) { cap = false; }
    el.setAttribute('aria-label', el.textContent.replace(/\s+/g, ' ').trim());
    var idx = 0;
    var walker = doc.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) { return n.parentNode.closest('em') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT; }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var frag = doc.createDocumentFragment();
      n.nodeValue.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) { frag.appendChild(doc.createTextNode(' ')); return; }
        var w = doc.createElement('span');
        w.className = 'w';
        w.setAttribute('aria-hidden', 'true');
        Array.from(part).forEach(function (c, ci) {
          var s = doc.createElement('span');
          s.className = 'ch';
          s.setAttribute('data-i', idx++);
          s.textContent = (cap && ci === 0) ? c.toUpperCase() : c;
          w.appendChild(s);
        });
        frag.appendChild(w);
      });
      n.parentNode.replaceChild(frag, n);
    });
    /* accent words (the swirl-filled <em>) are read as text, so keep their own aria */
    [].slice.call(el.querySelectorAll('em')).forEach(function (e) { e.setAttribute('aria-hidden', 'true'); });
    el.classList.add('fx');
  }

  var heads = [].slice.call(doc.querySelectorAll(
    '.hero h1, .page-title h1, .c-hero h1, .g-hero h1, .r-hero h1, .head h2, .story h2, .news h2, .parallax-text h2, .tools h2'
  )).filter(function (h) { return !h.closest('.pdp-info') && h.textContent.trim().length; });
  if (!heads.length) return;
  heads.forEach(split);

  function reset(h) {
    [].slice.call(h.querySelectorAll('.ch')).forEach(function (c) {
      c.style.translate = ''; c.style.scale = ''; c.style.rotate = '';
    });
    h.__hot = false; h.__c = null;
  }
  function apply(h, x, y) {
    var chars = [].slice.call(h.querySelectorAll('.ch'));
    if (!h.__c) {
      chars.forEach(function (c) { c.style.translate = ''; c.style.scale = ''; c.style.rotate = ''; });
      h.__c = chars.map(function (c) { var b = c.getBoundingClientRect(); return [b.left + b.width / 2, b.top + b.height / 2]; });
    }
    h.__hot = true;
    chars.forEach(function (c, i) {
      var p = h.__c[i], dx = p[0] - x, dy = p[1] - y;
      var d = Math.sqrt(dx * dx + dy * dy) || 1;
      var f = Math.max(0, 1 - d / R);
      if (f <= 0) { c.style.translate = ''; c.style.scale = ''; c.style.rotate = ''; return; }
      c.style.translate = (dx / d * f * 24).toFixed(1) + 'px ' + (dy / d * f * 24).toFixed(1) + 'px';
      c.style.scale = (1 + f * 0.6).toFixed(2);
      c.style.rotate = (dx > 0 ? 1 : -1) * f * 16 + 'deg';
    });
  }
  function onMove(e) {
    heads.forEach(function (h) {
      var r = h.getBoundingClientRect();
      var near = e.clientX > r.left - R && e.clientX < r.right + R && e.clientY > r.top - R && e.clientY < r.bottom + R;
      if (near) apply(h, e.clientX, e.clientY); else if (h.__hot) reset(h);
    });
  }
  var tick = false;
  doc.addEventListener('pointermove', function (e) {
    if (e.pointerType === 'touch' || tick) return;
    tick = true;
    requestAnimationFrame(function () { tick = false; onMove(e); });
  }, { passive: true });
  /* touch: a tap on a heading sends a ripple through the letters */
  doc.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'touch') return;
    onMove(e);
    setTimeout(function () { heads.forEach(function (h) { if (h.__hot) reset(h); }); }, 700);
  }, { passive: true });
  var inv = function () { heads.forEach(function (h) { h.__c = null; }); };
  window.addEventListener('scroll', inv, { passive: true });
  window.addEventListener('resize', inv);
})();
